import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstace from "../../api/axiosInstance";

export const fetchDebtAllUser = createAsyncThunk(
  "fetchDebt",
  async ({ page = 1, limit = 8, searchQuery = "" }) => {
    try {
      const response = await axiosInstace.get("/debt/getDriveSchool", {
        params: {
          page,
          limit,
          value: searchQuery,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getAllPaymet = createAsyncThunk(
  "getAllPayment",
  async (req, res) => {
    try {
      const response = await axiosInstace.get("/payment/getAllPayment");
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const payDebtDriveSchool = createAsyncThunk(
  "peyDebtDriveSchool",
  async (data) => {
    try {
      const response = await axiosInstace.post(
        "/debt/payDebtDriveSchool",
        data
      );

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getDebtForEachDriveSchool = createAsyncThunk(
  "getDebtForEachDriveSchool",
  async (id) => {
    try {
      const response = await axiosInstace.get(
        `/debt/getDebtForEachDriveSchool?driveSchool_id=${id}`
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Something went wrong");
    }
  }
);

export const getAllDebt = createAsyncThunk("getAllDebt", async () => {
  try {
    const response = await axiosInstace.get("/payment/getAllDebt");
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message);
  }
});

export const resetPay = createAsyncThunk("resetPay", async (id) => {
  try {
    const response = await axiosInstace.post(`/payments/resetPayment/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message);
  }
});

export const toggleHideOrShowEarnings = createAsyncThunk(
  "payments/toggleHideOrShowEarnings",
  async (driveSchoolId, { rejectWithValue }) => {
    try {
      const response = await axiosInstace.put(
        `/payments/HideOrShowEarnings/${driveSchoolId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const getAllTransaksionet = createAsyncThunk(
  "payment/getTransactionsInfo",
  async ({ page = 1, limit = 8, searchQuery = "", status = "" }) => {
    try {
      const response = await axiosInstace.get("/payment/getTransactionsInfo", {
        params: {
          page,
          limit,
          value: searchQuery,
          status,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getAllCards = createAsyncThunk(
  "cards/getAllCards",
  async ({ page = 1, limit = 8, searchQuery = "" }) => {
    try {
      const response = await axiosInstace.get("/cards/getAllCards", {
        params: {
          page,
          limit,
          value: searchQuery,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

const debtSlice = createSlice({
  name: "debt",
  initialState: {
    data: [],
    loading: false,
    error: null,
    payDebtStatus: false,
    payDebtLoading: false,
    payDebtError: null,
    paymentData: [],
    loadindPaymentData: false,
    errorPaymentData: null,
    allDebt: [],
    loadingAllDebt: false,
    errorAllDebt: null,
    resetPay: [],
    errorResetPay: null,
    loadingResetPay: false,
    transaksionet: [],
    cards: [],
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    debtForEachSchool: [],
    loadingDebtForEachSchool: false,
    errorDebtForEachSchool: null,
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPay.fulfilled, (state, action) => {
        state.loadingResetPay = false;
        state.resetPay = action.payload;
      })
      .addCase(resetPay.rejected, (state, action) => {
        state.errorResetPay = action.error.message;
        state.loadingResetPay = false;
      })
      .addCase(resetPay.pending, (state) => {
        state.loadingResetPay = true;
        state.errorResetPay = null;
      })
      .addCase(getAllDebt.pending, (state) => {
        state.loadingAllDebt = true;
        state.errorAllDebt = null;
      })
      .addCase(getAllDebt.fulfilled, (state, action) => {
        state.loadingAllDebt = false;
        state.allDebt = action.payload;
      })
      .addCase(getAllDebt.rejected, (state, action) => {
        state.loadingAllDebt = false;
        state.errorAllDebt = action.error.message;
      })
      .addCase(getAllPaymet.pending, (state) => {
        state.loadindPaymentData = true;
        state.errorPaymentData = null;
      })
      .addCase(getAllPaymet.fulfilled, (state, action) => {
        state.loadindPaymentData = false;
        state.paymentData = action.payload;
      })
      .addCase(getAllPaymet.rejected, (state, action) => {
        state.loadindPaymentData = false;
        state.errorPaymentData = action.error.message;
      })
      .addCase(fetchDebtAllUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDebtAllUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchDebtAllUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(payDebtDriveSchool.pending, (state) => {
        state.payDebtLoading = true;
        state.payDebtError = null;
      })
      .addCase(payDebtDriveSchool.fulfilled, (state, action) => {
        state.payDebtStatus = !state.payDebtStatus;
      })
      .addCase(payDebtDriveSchool.rejected, (state, action) => {
        state.payDebtLoading = false;
        state.payDebtError = action.error.message;
      })
      .addCase(getAllTransaksionet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTransaksionet.fulfilled, (state, action) => {
        state.loading = false;
        state.transaksionet = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getAllTransaksionet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getAllCards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCards.fulfilled, (state, action) => {
        state.loading = false;
        state.cards = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getAllCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getDebtForEachDriveSchool.pending, (state) => {
        state.loadingDebtForEachSchool = true;
        state.errorDebtForEachSchool = null;
      })
      .addCase(getDebtForEachDriveSchool.fulfilled, (state, action) => {
        state.loadingDebtForEachSchool = false;
        state.debtForEachSchool = action.payload;
      })
      .addCase(getDebtForEachDriveSchool.rejected, (state, action) => {
        state.loadingDebtForEachSchool = false;
        state.errorDebtForEachSchool = action.error.message;
      })
      .addCase(toggleHideOrShowEarnings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleHideOrShowEarnings.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(toggleHideOrShowEarnings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPage } = debtSlice.actions;
export const selectAllDebt = (state) => state.debt.data;
export const selectAllPayment = (state) => state.debt.paymentData;
export default debtSlice.reducer;
